// @flow

/**
 * Module dependencies.
 */

import { colors } from 'client/styles';
import { prop } from 'styled-tools';
import styled from 'styled-components';

/**
 * Export `Section` component.
 */

export const Section = styled.section`
  background-color: ${prop('bgColor', colors.white)};
  position: relative;
`;



// WEBPACK FOOTER //
// ../src/client/components/core/grid/section.js